module.exports = __webpack_public_path__ + "static/img/Round-15-2016.ec7a90f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-15-2016.jpg
// module id = Tl6R
// module chunks = 0